import { useContext } from 'react';

import { LoadingContext } from '../context/Loading.context.js';

/**
 * @internal
 */
export const useChartLayoutLoading = () => useContext(LoadingContext);
